import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { PayableUpdateDialogComponent } from './payable-update-dialog.component';
import { PayableUpdateDialogStateService } from './payable-update-dialog-state.service';

@Component({
    selector: 'app-payable-update-dialog-host',
    standalone: true,
    imports: [NgIf, PayableUpdateDialogComponent],
    template: '<app-payable-update-dialog *ngIf="state.open()" [open]="state.open()" [payableId]="state.payableId()" (closed)="state.answer($event)"></app-payable-update-dialog>',
})
export class PayableUpdateDialogHostComponent
{
    constructor(readonly state: PayableUpdateDialogStateService) {}
}
